import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const ReplyLibrary = () => import('./replyLibrary/Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tools/reply-library'),
    name: 'reply_library',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: ReplyLibrary,
  },
];
